// TUNE-12025: the adswizz listener id and global function are
// set internally by the AdsWizz SDK scripts in Mint
export default () =>
  window.com_adswizz_synchro_getListenerId &&
  window.com_adswizz_synchro_getListenerId();
